import { useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useClassStudentSearchDropdown } from '../../../hooks/useClassStudentSearchDropdown';

import type { LookupAutocompleteProps } from './StudentAutocomplete';

/** Autocomplete de turma (lookup `courseregistration/shared/class-student-list`). */
export function ClassStudentAutocomplete({
  value,
  selectedLabel,
  onChange,
  label,
  placeholder,
}: LookupAutocompleteProps) {
  const [search, setSearch] = useState('');
  const { options, isQuerySuccess } = useClassStudentSearchDropdown(search);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value}
      selectedLabel={selectedLabel}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id, itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange('', '');
        setSearch('');
      }}
    />
  );
}
